import React, {FC} from "react"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {H1, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import Modal from "@irati/ui/src/GenericModal"

interface Props extends InjectIntl {
  onCloseModal: () => void,
  onLinkClicked: () => void,
  showModal?: boolean
}

const CloseBannerModal: FC<Props> = ({onCloseModal, formatMessage, onLinkClicked, showModal}) => {
  return (
    <Modal
      show={showModal}
      image={formatMessage({id: "perks.containers.homepage.customisation.modalImage"})}
      hideActions
      critical
      imageBackgroundColor="transparent">
      <H1 marginBottom={2}>
        <FormattedMessage id="perks.containers.homepage.customisation.modalHeader" />
      </H1>
      <Body>
        <FormattedMessage
          id="perks.containers.homepage.customisation.modalText"
          values={{
            link: (
              <Button tertiary cta large onClick={onLinkClicked}>
                <FormattedMessage id="perks.containers.homepage.customisation.modalLink" />
              </Button>
            )
          }} />
      </Body>
      <Flex justifyContent="flex-end" marginTop={2}>
        <Button primary onClick={onCloseModal}>
          <FormattedMessage id="perks.containers.homepage.customisation.modalButtonLabel" />
        </Button>
      </Flex>
    </Modal>
  )
}

export default injectIntl(CloseBannerModal)
